"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * useRefetch hook to periodically refetch data at a specified interval.
 *
 * @param {Function} refetchFunction The function to call for refetching data.
 * @param {number} intervalDuration The interval duration in milliseconds.
 * @param {Array} dependencies Optional dependencies array to control when the effect runs.
 * @returns {void}
 */
function useRefetch(refetchFunction, intervalDuration, dependencies = []) {
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    const interval = setInterval(async () => {
      await refetchFunction(abortController);
    }, intervalDuration);
    return () => {
      clearInterval(interval);
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
var _default = exports.default = useRefetch;